/* =============================================================================
   ASP — Acoustic Assessment
   assets/acoustic-assessment.js

   Self-contained quiz + recommendation matrix. The product attribute table
   below is authoritative and does not depend on Shopify tags. Live data
   (titles, images, prices, availability) is pulled from the store at runtime
   and matched on product handle.
   ========================================================================== */

(function () {
  'use strict';

  /* --- Product attribute table. Regenerate from the Shopify export; do not
         hand-edit. See the install guide, section "Updating the catalogue". */
  var CATALOGUE = [{"h":"frontier™-drape-acoustic-fins","t":"Frontier™ Drape Acoustic Fins","surf":["ceiling-suspended"],"fmt":["fins"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":1.0,"uc":5.76,"moq":1,"u":"16 fins per pack","cpm":463,"role":"workhorse","ease":"trade"},{"h":"frontier™-glide-acoustic-fins","t":"Frontier™ Glide Acoustic Fins","surf":["ceiling-suspended"],"fmt":["fins"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":1.0,"uc":5.76,"moq":1,"u":"16 fins per pack","cpm":463,"role":"workhorse","ease":"trade"},{"h":"frontier™-ripple-acoustic-fins","t":"Frontier™ Ripple Acoustic Fins","surf":["ceiling-suspended"],"fmt":["fins"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":1.0,"uc":5.76,"moq":1,"u":"16 fins per pack","cpm":463,"role":"workhorse","ease":"trade"},{"h":"frontier™-wave-acoustic-fins","t":"Frontier™ Wave Acoustic Fins","surf":["ceiling-suspended"],"fmt":["fins"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":1.0,"uc":5.76,"moq":1,"u":"16 fins per pack","cpm":463,"role":"workhorse","ease":"trade"},{"h":"groove-wall-tiles","t":"Groove™ Wall Tiles","surf":["wall"],"fmt":["tiles"],"fin":"relief","perf":"mid","sp":["education","healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.8,"uc":2.88,"moq":1,"u":"8 tiles per box","cpm":208,"role":"workhorse","ease":"fix"},{"h":"composition-smooth-acoustic-fabric-per-meter","t":"Composition® Smooth Acoustic Fabric Roll - Per Meter","surf":["ceiling-direct","wall"],"fmt":["panels"],"fin":"flat","perf":"basic","sp":["education","healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.4,"uc":1.22,"moq":5,"u":"Per meter (min. 5)","cpm":130,"role":"workhorse","ease":"fix"},{"h":"quietspace-ceiling-tiles","t":"Quietspace Ceiling Tiles","surf":["ceiling-grid"],"fmt":["grid-tiles"],"fin":"flat","perf":"high","sp":["education","healthcare","office"],"diy":false,"calc":"area","nrc":0.85,"uc":2.81,"moq":1,"u":"4 tiles","cpm":147,"role":"workhorse","ease":"trade"},{"h":"quietspace-acoustic-panels-with-vertiface-colours","t":"Quietspace Acoustic Panels with Vertiface® Colours","surf":["ceiling-direct","wall"],"fmt":["panels"],"fin":"flat","perf":"high","sp":["education","healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":1.0,"uc":2.88,"moq":6,"u":"Per panel (min. 6)","cpm":169,"role":"workhorse","ease":"fix"},{"h":"groove-duet","t":"Groove Duet™","surf":["wall"],"fmt":["panels"],"fin":"relief","perf":"mid","sp":[],"diy":false,"calc":"area","nrc":0.8,"uc":2.88,"moq":10,"u":"Per panel (min. 10)","cpm":276,"role":"workhorse","ease":"fix"},{"h":"acoustek-louvre-acoustic-blades","t":"Louvre Acoustic Blades","surf":["wall"],"fmt":["tiles"],"fin":"relief","perf":"high","sp":[],"diy":false,"calc":"area","nrc":0.95,"uc":1.44,"moq":1,"u":"Per unit","cpm":895,"role":"feature","ease":"fix"},{"h":"verve-contoured-panel-printed","t":"Verve™ Contoured Panel - Printed","surf":["wall"],"fmt":["panels"],"fin":"printed","perf":"basic","sp":[],"diy":false,"calc":"area","nrc":0.3,"uc":3.135,"moq":6,"u":"Per panel (min. 6)","cpm":410,"role":"workhorse","ease":"fix"},{"h":"verve-contoured-panel","t":"Verve™ Contoured Panel","surf":["wall"],"fmt":["panels"],"fin":"relief","perf":"basic","sp":[],"diy":false,"calc":"area","nrc":0.3,"uc":3.135,"moq":6,"u":"Per panel (min. 6)","cpm":248,"role":"workhorse","ease":"fix"},{"h":"groove-acoustic-panels-timber","t":"Groove Acoustic Panels Timber","surf":["wall"],"fmt":["panels"],"fin":"timber","perf":"mid","sp":["education","healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.8,"uc":null,"moq":4,"u":"Per panel (min. 4)","cpm":340,"role":"workhorse","ease":"fix"},{"h":"harp-acoustic-wall-blades","t":"Harp Acoustic Wall Blades","surf":["wall"],"fmt":["tiles"],"fin":"relief","perf":"high","sp":["healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.95,"uc":1.44,"moq":1,"u":"Per unit","cpm":850,"role":"feature","ease":"fix"},{"h":"crocus-acoustic-lighting-shade","t":"Crocus Acoustic Lighting Shade","surf":["ceiling-suspended"],"fmt":["lighting"],"fin":"lighting","perf":"mid","sp":[],"diy":false,"calc":"accent","nrc":0.8,"uc":null,"moq":1,"u":"Per unit","cpm":null,"role":"workhorse","ease":"trade"},{"h":"grid-ceiling-tiles-bulk-pack","t":"Grid Ceiling Tiles - Bulk Pack","surf":["ceiling-grid"],"fmt":["grid-tiles"],"fin":"flat","perf":"high","sp":[],"diy":false,"calc":"area","nrc":0.85,"uc":8.5,"moq":1,"u":"Per pack - 24 tiles","cpm":342,"role":"workhorse","ease":"trade"},{"h":"acoustek-zephyr-lighting-shades","t":"Zephyr Acoustic Lighting Shades","surf":["ceiling-suspended"],"fmt":["lighting"],"fin":"lighting","perf":"high","sp":[],"diy":false,"calc":"accent","nrc":0.85,"uc":null,"moq":1,"u":"Per unit","cpm":null,"role":"workhorse","ease":"trade"},{"h":"acoustek-breeze","t":"Breeze Acoustic Lighting Shades","surf":["ceiling-suspended"],"fmt":["lighting"],"fin":"lighting","perf":"high","sp":[],"diy":false,"calc":"accent","nrc":0.85,"uc":null,"moq":1,"u":"Per unit","cpm":null,"role":"workhorse","ease":"trade"},{"h":"autex-grid-ceiling-tiles-capped","t":"Grid Ceiling Tiles","surf":["ceiling-grid"],"fmt":["grid-tiles"],"fin":"flat","perf":"high","sp":[],"diy":false,"calc":"area","nrc":0.85,"uc":2.83,"moq":1,"u":"Per pack - 8 tiles (Square) | 4 tiles (Recta","cpm":567,"role":"workhorse","ease":"trade"},{"h":"autex-lanes-printed","t":"Lanes™ Panels - Printed","surf":["wall"],"fmt":["panels"],"fin":"printed","perf":"high","sp":[],"diy":false,"calc":"area","nrc":0.85,"uc":2.16,"moq":1,"u":"3 lanes per pack","cpm":571,"role":"workhorse","ease":"trade"},{"h":"autex-lanes-colour","t":"Lanes™ Panels - Colour","surf":["wall"],"fmt":["panels"],"fin":"relief","perf":"high","sp":[],"diy":false,"calc":"area","nrc":0.85,"uc":2.16,"moq":1,"u":"3x lanes per pack","cpm":452,"role":"workhorse","ease":"trade"},{"h":"autex-mirage-textured-panel","t":"Mirage™  Textured Panel","surf":["wall"],"fmt":["panels"],"fin":"relief","perf":"mid","sp":[],"diy":false,"calc":"area","nrc":0.8,"uc":2.88,"moq":6,"u":"Per panel (min. 6)","cpm":327,"role":"workhorse","ease":"fix"},{"h":"autex-frontier-raft-trapezoid","t":"Frontier Raft Acoustic System - Trapezoid","surf":["ceiling-suspended"],"fmt":["rafts"],"fin":"flat","perf":"high","sp":[],"diy":false,"calc":"area","nrc":0.95,"uc":2.88,"moq":1,"u":"4 rafts per pack","cpm":754,"role":"workhorse","ease":"trade"},{"h":"autex-frontier-raft-blade","t":"Frontier Raft Acoustic System - Blade","surf":["ceiling-suspended"],"fmt":["rafts"],"fin":"flat","perf":"high","sp":[],"diy":false,"calc":"area","nrc":0.95,"uc":2.88,"moq":1,"u":"4 rafts per pack","cpm":736,"role":"workhorse","ease":"trade"},{"h":"autex-frontier-raft-beam-250","t":"Frontier Raft Acoustic System - Beam 250","surf":["ceiling-suspended"],"fmt":["rafts"],"fin":"flat","perf":"high","sp":[],"diy":false,"calc":"area","nrc":0.95,"uc":2.88,"moq":1,"u":"Per Pack Beam 250: 8 pcs (1200) | 4 pcs (240","cpm":754,"role":"workhorse","ease":"trade"},{"h":"acoufelt-quietform-tiles-kalos","t":"QuietForm™ 3D Acoustic Tiles - Kalos","surf":["wall"],"fmt":["tiles"],"fin":"relief","perf":"basic","sp":["hospitality","office"],"diy":true,"calc":"area","nrc":0.45,"uc":2.88,"moq":1,"u":"8 tiles per box","cpm":434,"role":"workhorse","ease":"peel"},{"h":"acoufelt-quietform-tiles-pole","t":"QuietForm™ 3D Acoustic Tiles - Pole","surf":["wall"],"fmt":["tiles"],"fin":"relief","perf":"basic","sp":["hospitality","office"],"diy":true,"calc":"area","nrc":0.45,"uc":2.88,"moq":1,"u":"8 tiles per box","cpm":434,"role":"workhorse","ease":"peel"},{"h":"acoufelt-quietform-tiles-flute","t":"QuietForm™ 3D Acoustic Tiles - Flute","surf":["wall"],"fmt":["tiles"],"fin":"relief","perf":"basic","sp":["hospitality","office"],"diy":true,"calc":"area","nrc":0.45,"uc":2.88,"moq":1,"u":"8 tiles per box","cpm":434,"role":"workhorse","ease":"peel"},{"h":"autex-willie-weston-collection-2700","t":"Willie Weston Collection Acoustic Panels - 2700 x 1200mm","surf":["ceiling-direct","wall"],"fmt":["panels"],"fin":"printed","perf":"high","sp":["healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.85,"uc":3.24,"moq":4,"u":"Per panel (min. 4)","cpm":336,"role":"workhorse","ease":"fix"},{"h":"autex-cascade-hanging-screens-folding","t":"Cascade™ Hanging Screens – Folding","surf":["freestanding","wall"],"fmt":["panels","screens"],"fin":"flat","perf":"high","sp":["office"],"diy":false,"calc":"accent","nrc":null,"uc":null,"moq":1,"u":"Per screen","cpm":null,"role":"workhorse","ease":"trade"},{"h":"autex-cascade-hanging-screens-expanding","t":"Cascade™ Hanging Screens - Expanding","surf":["freestanding","wall"],"fmt":["panels","screens"],"fin":"flat","perf":"high","sp":["office"],"diy":false,"calc":"accent","nrc":null,"uc":null,"moq":1,"u":"Per screen","cpm":null,"role":"workhorse","ease":"trade"},{"h":"autex-horizon-hanging-acoustics","t":"Horizon Hanging Acoustics","surf":["ceiling-direct","ceiling-suspended","wall"],"fmt":["hanging","panels"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":0.8,"uc":2.262,"moq":1,"u":"Per pack - Circle: 2 | Hexagon: 2 | Rectangl","cpm":484,"role":"workhorse","ease":"trade"},{"h":"autex-3d-acoustic-wall-tiles","t":"3D Acoustic Wall Tiles","surf":["wall"],"fmt":["tiles"],"fin":"relief","perf":"high","sp":["office"],"diy":true,"calc":"area","nrc":0.9,"uc":1.98,"moq":1,"u":"6 tiles per pack","cpm":379,"role":"workhorse","ease":"fix"},{"h":"autex-frontier-raft-acoustic-system","t":"Frontier Raft Acoustic System - Beam 100","surf":["ceiling-suspended"],"fmt":["rafts"],"fin":"flat","perf":"high","sp":[],"diy":false,"calc":"area","nrc":0.95,"uc":2.88,"moq":1,"u":"8 rafts per pack","cpm":754,"role":"workhorse","ease":"trade"},{"h":"acoufelt-fracture-acoustic-tiles","t":"Acoufelt Fracture Wall Panels","surf":["wall"],"fmt":["tiles"],"fin":"relief","perf":"basic","sp":[],"diy":true,"calc":"area","nrc":0.64,"uc":3.24,"moq":1,"u":"18 tiles per box","cpm":340,"role":"workhorse","ease":"fix"},{"h":"autex-groove-acoustic-panels","t":"Groove Acoustic Panels","surf":["wall"],"fmt":["panels"],"fin":"relief","perf":"mid","sp":["education","healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.8,"uc":2.88,"moq":2,"u":"Per panel (min. 2)","cpm":214,"role":"workhorse","ease":"fix"},{"h":"acoufelt-quietform-tiles-celestial","t":"QuietForm™ 3D Acoustic Tiles - Celestial","surf":["wall"],"fmt":["tiles"],"fin":"relief","perf":"basic","sp":["hospitality","office"],"diy":true,"calc":"area","nrc":0.45,"uc":2.88,"moq":1,"u":"8 tiles per box","cpm":434,"role":"workhorse","ease":"peel"},{"h":"acoustek-pergola-with-integrated-led-lighting","t":"Pergola Acoustic Ceiling Raft w/ LED Lighting Tracks","surf":["ceiling-suspended"],"fmt":["lighting"],"fin":"lighting","perf":"high","sp":["hospitality","office"],"diy":false,"calc":"accent","nrc":null,"uc":2.88,"moq":1,"u":"Per unit","cpm":691,"role":"workhorse","ease":"trade"},{"h":"acoustek-wallflower-3d-acoustic-tiles","t":"WallFlower 3D Acoustic Panels","surf":["wall"],"fmt":["panels"],"fin":"relief","perf":"high","sp":["education","hospitality","office"],"diy":false,"calc":"area","nrc":0.85,"uc":0.64,"moq":1,"u":"4 Wallflowers per box (per colour)","cpm":804,"role":"feature","ease":"fix"},{"h":"acoustek-clover-3d-acoustic-tiles","t":"Clover 3D Acoustic Wall Panels","surf":["wall"],"fmt":["panels"],"fin":"relief","perf":"high","sp":["education","hospitality","office"],"diy":true,"calc":"area","nrc":0.85,"uc":0.64,"moq":1,"u":"4 Clovers per box (per colour)","cpm":804,"role":"feature","ease":"fix"},{"h":"acoustek-newport-collection","t":"Newport Collection - Acoustic Wall Tiles","surf":["wall"],"fmt":["tiles"],"fin":"flat","perf":"mid","sp":["healthcare","hospitality","office"],"diy":true,"calc":"area","nrc":0.7,"uc":2.25,"moq":1,"u":"9 tiles per pack","cpm":433,"role":"workhorse","ease":"fix"},{"h":"acoustek-cavasinni-collection-acoustic-wall-tiles","t":"Cavasinni Collection - Acoustic Wall Tiles","surf":["wall"],"fmt":["tiles"],"fin":"flat","perf":"mid","sp":["healthcare","hospitality","office"],"diy":true,"calc":"area","nrc":0.7,"uc":2.25,"moq":1,"u":"9 tiles per pack","cpm":455,"role":"workhorse","ease":"fix"},{"h":"acoustek-petal-acoustic-light-shades","t":"Petal Acoustic Lighting Shade","surf":["ceiling-suspended"],"fmt":["lighting"],"fin":"lighting","perf":"high","sp":["hospitality","office"],"diy":false,"calc":"accent","nrc":0.7,"uc":null,"moq":1,"u":"Per unit","cpm":null,"role":"workhorse","ease":"trade"},{"h":"autex-emma-hayes-collection","t":"Emma Hayes Collection - Acoustic Panels","surf":["ceiling-direct","wall"],"fmt":["panels"],"fin":"printed","perf":"high","sp":["healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.85,"uc":2.88,"moq":6,"u":"Per panel (min. 6)","cpm":299,"role":"workhorse","ease":"fix"},{"h":"composition-velour-acoustic-panels-rolls","t":"Composition® Velour Acoustic Panel Roll - Per Meter","surf":["ceiling-direct","wall"],"fmt":["panels"],"fin":"flat","perf":"basic","sp":["education","healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.4,"uc":1.22,"moq":5,"u":"Per meter (min. 5)","cpm":107,"role":"workhorse","ease":"fix"},{"h":"autex-frontier-dune-acoustic-fins","t":"Frontier™ Dune Acoustic Fins","surf":["ceiling-suspended"],"fmt":["fins"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":1.0,"uc":2.88,"moq":1,"u":"8 fins per pack","cpm":338,"role":"workhorse","ease":"trade"},{"h":"autex-frontier-tundra-acoustic-fins","t":"Frontier™ Tundra Acoustic Fins","surf":["ceiling-suspended"],"fmt":["fins"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":1.0,"uc":5.67,"moq":1,"u":"150mm - 8 fins | 300mm - 16 fins","cpm":null,"role":"workhorse","ease":"trade"},{"h":"autex-frontier-sierra-acoustic-fins","t":"Frontier™ Sierra Acoustic Fins","surf":["ceiling-suspended"],"fmt":["fins"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":1.0,"uc":5.76,"moq":1,"u":"8 fins per pack","cpm":338,"role":"workhorse","ease":"trade"},{"h":"autex-frontier-axis-acoustic-fins","t":"Frontier™ Axis Acoustic Fins","surf":["ceiling-suspended"],"fmt":["fins"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":1.0,"uc":5.76,"moq":1,"u":"16 fins per pack","cpm":338,"role":"workhorse","ease":"trade"},{"h":"autex-willie-weston-collection-acoustic-panels","t":"Willie Weston Collection Acoustic Panels - 2400 x 1200mm","surf":["ceiling-direct","wall"],"fmt":["panels"],"fin":"printed","perf":"high","sp":["healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.85,"uc":2.88,"moq":4,"u":"Per panel (min. 4)","cpm":336,"role":"workhorse","ease":"fix"},{"h":"autex-frontier-talus-acoustic-fins","t":"Frontier™ Talus Acoustic Fins","surf":["ceiling-suspended"],"fmt":["fins"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":1.0,"uc":5.76,"moq":1,"u":"8 fins per pack","cpm":338,"role":"workhorse","ease":"trade"},{"h":"composition-smooth-acoustic-panels","t":"Composition® Smooth Acoustic Panels","surf":["wall"],"fmt":["panels"],"fin":"flat","perf":"basic","sp":["education","healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.55,"uc":2.88,"moq":3,"u":"12mm - minimum 3 panels | 18mm - minimum 6 p","cpm":113,"role":"workhorse","ease":"fix"},{"h":"honeycomb-acoustic-tiles","t":"Cube™ Honeycomb Acoustic Tiles","surf":["ceiling-direct","wall"],"fmt":["tiles"],"fin":"relief","perf":"mid","sp":["education","hospitality","office"],"diy":false,"calc":"area","nrc":0.8,"uc":2.8,"moq":1,"u":"40 tiles per pack","cpm":252,"role":"workhorse","ease":"fix"},{"h":"woodbequiet-acoustic-wall-planks","t":"WoodBeQuiet™ Acoustic Wall Planks","surf":["ceiling-direct","wall"],"fmt":["tiles"],"fin":"timber","perf":"basic","sp":["hospitality","office"],"diy":true,"calc":"area","nrc":0.45,"uc":4.5,"moq":1,"u":"15 planks per box","cpm":181,"role":"workhorse","ease":"peel"},{"h":"autex-acoustic-timber-ceiling-tiles","t":"Acoustic Timber Ceiling Tiles","surf":["ceiling-grid"],"fmt":["grid-tiles"],"fin":"timber","perf":"high","sp":["education","healthcare","office"],"diy":false,"calc":"area","nrc":0.9,"uc":5.68,"moq":1,"u":"8 tiles per pack","cpm":257,"role":"workhorse","ease":"trade"},{"h":"autex-acoustic-timber-panels","t":"Acoustic Timber Panels","surf":["wall"],"fmt":["panels"],"fin":"timber","perf":"high","sp":["healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.9,"uc":2.88,"moq":4,"u":"Per panel (min. 4)","cpm":266,"role":"workhorse","ease":"fix"},{"h":"autex-vertiface","t":"Vertiface® Acoustic Fabric (Per Metre)","surf":["wall"],"fmt":["roll"],"fin":"flat","perf":"unrated","sp":["hospitality","office"],"diy":false,"calc":"area","nrc":null,"uc":1.3,"moq":5,"u":"Per meter (min. 5)","cpm":45,"role":"workhorse","ease":"trade"},{"h":"lattice-suspended-acoustic-sculpture","t":"Lattice™ Suspended Acoustic Sculpture","surf":["ceiling-suspended"],"fmt":["rafts"],"fin":"flat","perf":"high","sp":["education","hall","office"],"diy":false,"calc":"area","nrc":0.75,"uc":2.81,"moq":1,"u":"Trapezium & Eclipse: One unit per pack, Toru","cpm":711,"role":"workhorse","ease":"trade"},{"h":"composition-acoustic-panels","t":"Composition® Velour Acoustic Panels","surf":["wall"],"fmt":["roll"],"fin":"flat","perf":"basic","sp":["education","healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.55,"uc":2.88,"moq":3,"u":"12mm - minimum 3 panels | 18mm - minimum 6 p","cpm":120,"role":"workhorse","ease":"fix"},{"h":"acoustic-timber-raft","t":"Acoustic Timber Rafts","surf":["ceiling-grid","wall"],"fmt":["grid-tiles","panels"],"fin":"timber","perf":"high","sp":["education","office"],"diy":false,"calc":"area","nrc":0.9,"uc":2.88,"moq":1,"u":"Beam 250 (4 per pack) and Beam 100 (8 per pa","cpm":763,"role":"workhorse","ease":"trade"},{"h":"vicinity-acoustic-screen-system","t":"Vicinity™ Acoustic Screen System","surf":["freestanding"],"fmt":["screens"],"fin":"flat","perf":"unrated","sp":["education","office"],"diy":false,"calc":"accent","nrc":null,"uc":null,"moq":1,"u":"unit","cpm":null,"role":"workhorse","ease":"trade"},{"h":"cube-acoustic-panels","t":"Cube™ Acoustic Panels","surf":["ceiling-direct","wall"],"fmt":["panels"],"fin":"flat","perf":"mid","sp":["education","healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":0.8,"uc":2.88,"moq":3,"u":"Per panel (min. 3)","cpm":147,"role":"workhorse","ease":"fix"},{"h":"quietspace-acoustic-panels","t":"Quietspace Acoustic Panels","surf":["ceiling-direct","wall"],"fmt":["panels"],"fin":"flat","perf":"high","sp":["education","healthcare","hospitality","office"],"diy":false,"calc":"area","nrc":1.0,"uc":2.88,"moq":3,"u":"Per panel (min. 3)","cpm":127,"role":"workhorse","ease":"fix"},{"h":"accent-ceiling-tile","t":"Accent Ceiling Tile","surf":["ceiling-grid"],"fmt":["grid-tiles"],"fin":"flat","perf":"high","sp":["education","healthcare","office"],"diy":false,"calc":"area","nrc":0.85,"uc":5.664,"moq":1,"u":"595 mm × 595 mm (16 tiles) | 1195 mm × 595:m","cpm":234,"role":"workhorse","ease":"trade"},{"h":"3d-acoustic-ceiling-tiles","t":"3D Acoustic Ceiling Tiles","surf":["ceiling-direct","ceiling-grid"],"fmt":["grid-tiles","tiles"],"fin":"relief","perf":"high","sp":["office"],"diy":false,"calc":"area","nrc":0.9,"uc":null,"moq":1,"u":"8 tiles per pack per colour per style","cpm":null,"role":"workhorse","ease":"trade"},{"h":"autex-cove-desk-divider-screen","t":"Cove™ Desk Dividers (6 Pack)","surf":["desk","freestanding"],"fmt":["screens"],"fin":"flat","perf":"unrated","sp":["education","office"],"diy":false,"calc":"accent","nrc":null,"uc":null,"moq":1,"u":"6 screens per pack (choose style per pack)","cpm":null,"role":"workhorse","ease":"peel"},{"h":"autex-cascade-hanging-screens-static","t":"Cascade™ Hanging Screens – Static","surf":["freestanding","wall"],"fmt":["panels","screens"],"fin":"flat","perf":"high","sp":["office"],"diy":false,"calc":"accent","nrc":null,"uc":null,"moq":1,"u":"Per screen","cpm":null,"role":"workhorse","ease":"trade"},{"h":"peel-n-stick-pinnable-acoustic-tiles-bulk-pack","t":"Composition® Peel n Stick Acoustic Tiles - Bulk Pack (36 Tiles)","surf":["wall"],"fmt":["tiles"],"fin":"flat","perf":"basic","sp":["education","healthcare","hospitality","office"],"diy":true,"calc":"area","nrc":0.4,"uc":12.96,"moq":1,"u":"36 tiles (6 packs of 6 tiles)","cpm":152,"role":"workhorse","ease":"peel"},{"h":"peel-stick-pinnable-tiles","t":"Composition® Peel n Stick Acoustic Tiles (6 Tiles)","surf":["wall"],"fmt":["tiles"],"fin":"flat","perf":"basic","sp":["education","healthcare","hospitality","office"],"diy":true,"calc":"area","nrc":0.4,"uc":2.16,"moq":1,"u":"6 tiles per box","cpm":174,"role":"workhorse","ease":"peel"}];

  var BY_HANDLE = {};
  CATALOGUE.forEach(function (p) { BY_HANDLE[p.h] = p; });

  /* --- Question definitions. Order here is the order shown. ---------------- */
  var QUESTIONS = [
    {
      id: 'space', type: 'single',
      title: 'What kind of space are you treating?',
      options: [
        { v: 'office',      label: 'Office or workplace' },
        { v: 'education',   label: 'School, classroom or childcare' },
        { v: 'hospitality', label: 'Café, restaurant, bar or venue' },
        { v: 'healthcare',  label: 'Clinic, consulting room or healthcare' },
        { v: 'hall',        label: 'Hall, church or community space' },
        { v: 'residential', label: 'Home or residential', exit: 'residential' },
        { v: 'other',       label: 'Something else', exit: 'other' }
      ]
    },
    {
      id: 'problem', type: 'single',
      title: "What's happening in the space right now?",
      help: 'Pick whichever sounds most like your problem. If it is more than one, say so.',
      options: [
        { v: 'echo',    label: 'Echo and voices carrying. Hard to hear people, hard to concentrate.' },
        { v: 'incoming',label: 'Noise coming in from outside, next door or upstairs.' },
        { v: 'escaping',label: 'Our noise escaping and disturbing people outside the room.' },
        { v: 'both',    label: "It's a bit of both, or I'm not sure which" }
      ]
    },
    {
      id: 'surfaces', type: 'multi', min: 1,
      title: 'Where can the panels go?',
      help: "Tick anything we're allowed to use. Leave out anything covered by windows, cabinetry, air-con or sprinklers, or anything your lease won't let you touch.",
      options: [
        { v: 'wall',              label: 'The walls' },
        { v: 'ceiling-direct',    label: 'The ceiling, fixed straight onto it (solid or plasterboard)' },
        { v: 'ceiling-grid',      label: 'Drop ceiling with removable tiles (standard office grid)' },
        { v: 'ceiling-suspended', label: 'Open ceiling with ducts, pipes or beams on show' },
        { v: 'unsure',            label: "Not sure yet", exclusive: true }
      ]
    },
    {
      id: 'knowsArea', type: 'single',
      title: 'Do you already know how much panel area you need?',
      help: "Panel area, not room size. If you have a square metre figure from a plan, an installer or a previous quote, use it. Otherwise give us the room size and we will work it out.",
      options: [
        { v: 'yes', label: 'Yes, I know the panel area in m²' },
        { v: 'no',  label: "No, give me the room size instead" }
      ]
    },
    {
      id: 'wallArea', type: 'number', min: 1, max: 3000, suffix: 'm²',
      title: 'How much wall do you want covered with panels?',
      help: 'In square metres of panelling, not the size of the wall. A rough figure is fine.',
      showIf: function (a) { return a.knowsArea === 'yes' && hasWall(a); }
    },
    {
      id: 'ceilingArea', type: 'number', min: 1, max: 3000, suffix: 'm²',
      title: 'How much ceiling do you want covered with panels?',
      help: 'In square metres of panelling, not the size of the ceiling. A rough figure is fine.',
      showIf: function (a) { return a.knowsArea === 'yes' && hasCeiling(a); }
    },
    {
      id: 'roomLength', type: 'number', min: 1, max: 200, suffix: 'm',
      title: 'How long is the room?',
      help: 'In metres. A 5 metre room is 5, not 5000.',
      showIf: function (a) { return a.knowsArea === 'no'; }
    },
    {
      id: 'roomWidth', type: 'number', min: 1, max: 200, suffix: 'm',
      title: 'How wide is the room?',
      help: 'In metres. A 4 metre room is 4, not 4000.',
      showIf: function (a) { return a.knowsArea === 'no'; }
    },
    {
      id: 'height', type: 'single',
      title: 'How high is the ceiling?',
      options: [
        { v: 2.4, label: 'Under 2.7 m — standard home height' },
        { v: 3.0, label: '2.7 m to 3.5 m — standard commercial' },
        { v: 4.5, label: '3.5 m to 6 m' },
        { v: 7.0, label: 'Over 6 m' },
        { v: 4.5, label: 'Exposed services or beams, hard to put a number on it' }
      ]
    },
    {
      id: 'result', type: 'single',
      title: 'How much treatment does the room need?',
      help: 'This sets how much of the room we cover, so it changes the quantity you see at the end.',
      options: [
        { v: 'basic', label: 'Light. Take the edge off. We cover about a fifth of the surface.' },
        { v: 'mid',   label: 'Moderate. Noticeably quieter and calmer. We cover about a quarter.' },
        { v: 'high',  label: 'Full. Speech needs to be clear. We cover about half.' }
      ]
    },
    {
      id: 'install', type: 'single',
      title: 'Do you require installation?',
      help: 'We install in Sydney, Melbourne, Brisbane and the Gold Coast. Everywhere else we supply and your installer fits it.',
      options: [
        { v: 'supply-install', label: 'Yes, supply and install' },
        { v: 'own-trades',     label: 'No, we have our own builder or trades' },
        { v: 'diy',            label: "No, I'll be installing it myself" }
      ]
    },
    {
      id: 'look', type: 'single',
      title: 'What kind of treatment are you after?',
      help: 'All of these work. This is about what you want in the room. Not sure? Pick no preference and we will show you what suits the space best.',
      options: [
        { v: 'any',      label: 'No preference — show me what works best' },
        { v: 'flat',     label: 'Flat fabric panels' },
        { v: 'relief',   label: 'Textured or 3D panels' },
        { v: 'printed',  label: 'Printed or custom artwork' },
        { v: 'timber',   label: 'Timber' },
        { v: 'suspended',label: 'Raft, fin or hanging systems' },
        { v: 'feature',  label: 'Feature and sculptural pieces' },
        { v: 'lighting', label: 'Acoustic lighting' }
      ]
    },
    {
      id: 'stage', type: 'single',
      title: 'Where are you up to?',
      options: [
        { v: 'researching', label: 'Just researching for now' },
        { v: 'specifying',  label: 'Putting a budget or specification together' },
        { v: 'ready',       label: 'Ready to order' }
      ]
    },
    /* Contact details are collected on the results page, in a real Shopify
       form, so the store's spam protection works normally. */
  ];

  var CEILING = ['ceiling-direct', 'ceiling-grid', 'ceiling-suspended'];
  function hasWall(a) {
    var s = a.surfaces || [];
    return s.indexOf('wall') > -1 || s.indexOf('unsure') > -1;
  }
  function hasCeiling(a) {
    var s = a.surfaces || [];
    if (s.indexOf('unsure') > -1) return true;
    return CEILING.some(function (c) { return s.indexOf(c) > -1; });
  }
  function surfaceSet(a) {
    var s = (a.surfaces || []).slice();
    if (s.indexOf('unsure') > -1) return ['wall', 'ceiling-direct'];
    return s;
  }

  /* --- The matrix --------------------------------------------------------- */
  var PERF_RANK = { high: 3, mid: 2, basic: 1, unrated: 0 };

  function allowedFormats(a) {
    var s = surfaceSet(a), f = {};
    if (s.indexOf('wall') > -1) { f.panels = 1; f.tiles = 1; f.roll = 1; }
    if (s.indexOf('ceiling-direct') > -1) { f.tiles = 1; f.panels = 1; }
    if (s.indexOf('ceiling-grid') > -1) { f['grid-tiles'] = 1; }
    if (s.indexOf('ceiling-suspended') > -1 && (a.height || 0) >= 3.5) {
      f.fins = 1; f.rafts = 1; f.hanging = 1; f.lighting = 1;
    }
    return f;
  }

  /* Share of each surface actually covered with panels. Approved by ASP.
     Only applied when we derive the area from room dimensions. If the customer
     gives us a panel area, that number is theirs and we use it untouched. */
  var COVER_RATIO = { basic: 0.20, mid: 0.25, high: 0.50 };

  function areas(a) {
    var wall = a.wallArea || null, ceiling = a.ceilingArea || null, est = false, ratio = null;
    if (a.knowsArea === 'no' && a.roomLength && a.roomWidth) {
      var h = a.height || 2.7;
      ratio = COVER_RATIO[a.result] || COVER_RATIO.mid;
      /* Surface area of the room, then the share of it we actually treat.
         Treating 100% of the walls was the old behaviour and it was wrong. */
      ceiling = a.roomLength * a.roomWidth * ratio;
      wall = 2 * (a.roomLength + a.roomWidth) * h * ratio;
      est = true;
    }
    return { wall: wall, ceiling: ceiling, estimated: est, ratio: ratio };
  }

  function run(a) {
    var trace = [], pool = CATALOGUE.slice(), n = pool.length;
    function gate(label, fn) {
      pool = pool.filter(fn);
      trace.push({ label: label, cut: n - pool.length, left: pool.length });
      n = pool.length;
    }
    var surf = surfaceSet(a), fmts = allowedFormats(a);

    gate('Surface', function (p) {
      return p.surf.some(function (s) { return surf.indexOf(s) > -1; });
    });
    gate('Format', function (p) { return p.fmt.some(function (f) { return !!fmts[f]; }); });
    /* Self-install is an explicit list from ASP, not something to infer. The
       DIY-Friendly tag and the install-method text both included grid tiles
       and suspended systems, which are not self-install jobs. */
    gate('Install', function (p) { return a.install !== 'diy' || p.diy === true; });
    /* Performance used to hard-exclude anything below the requested band, which
       wiped small pools: asking for "noticeably quieter" left only 4 of the 12
       self-install products and hid the best-selling one entirely. A lower-rated
       product is not wrong, it just needs more of it. So allow one band below
       and let the ranking prefer the higher performers. */
    var want = PERF_RANK[a.result || 'basic'];
    gate('Performance', function (p) { return PERF_RANK[p.perf] >= want - 1; });

    /* Feature and sculptural pieces are expensive per square metre and come in
       small units. Recommending 16 of them to cover a wall is nonsense, so they
       stay out unless someone deliberately asks for that kind of treatment. */
    if (a.look !== 'feature') {
      gate('Feature pieces', function (p) { return p.role !== 'feature'; });
    }

    var SUSPENDED = { fins: 1, rafts: 1, hanging: 1 };
    pool.forEach(function (p) {
      var wanted = 0;
      if (a.look === 'suspended') wanted = p.fmt.some(function (f) { return SUSPENDED[f]; }) ? 3 : 0;
      else if (a.look === 'feature') wanted = p.role === 'feature' ? 3 : 0;
      else if (a.look && a.look !== 'any') wanted = p.fin === a.look ? 3 : 0;
      var meets = PERF_RANK[p.perf] >= want ? 2 : 0;
      p._s = (p.sp.indexOf(a.space) > -1 ? 2 : (p.sp.length ? 0 : 1)) + wanted + meets;
    });
    /* A product we can price and quantify outranks one we cannot. Without this
       an item missing its coverage data can win on a 0.05 absorption edge and
       then show no quantity at all, which is the one thing this page is for. */
    var complete = function (p) { return (p.uc != null && p.cpm != null) ? 1 : 0; };
    /* Self-installers are buying on value. Everyone else is specifying, so
       absorption leads. This flips the order of the last two tiebreaks. */
    var diyPath = a.install === 'diy';
    pool.sort(function (x, y) {
      return y._s - x._s ||
             complete(y) - complete(x) ||
             (diyPath
               ? ((x.cpm || 9e9) - (y.cpm || 9e9)) || ((y.nrc || 0) - (x.nrc || 0))
               : ((y.nrc || 0) - (x.nrc || 0)) || ((x.cpm || 9e9) - (y.cpm || 9e9)));
    });

    /* The old hard NRC floor is gone. It duplicated the performance gate and
       silently blocked NRC 0.40 products from ever taking a slot, which is how
       the best-selling self-install tile became unreachable. */
    var wallPool = pool.filter(function (p) {
      return p.calc === 'area' && p.surf.indexOf('wall') > -1;
    });
    /* Only the ceiling types they actually selected. Matching any ceiling tag
       let a grid-only product through for a plasterboard ceiling. */
    var wantedCeil = surf.filter(function (s) { return CEILING.indexOf(s) > -1; });
    var ceilPool = pool.filter(function (p) {
      return p.calc === 'area' && p.surf.some(function (s) { return wantedCeil.indexOf(s) > -1; });
    });
    function best(list) { return list[0] || null; }

    var primary = hasWall(a) ? best(wallPool) : null;

    /* The ceiling slot must never be silenced just because the wall winner
       also happens to be ceiling-rated. Twelve products carry both surfaces,
       so picking the same item twice and then de-duplicating was killing the
       ceiling recommendation entirely. Exclude the primary and pick again,
       favouring formats actually designed for ceilings. */
    var secondary = null;
    if (hasCeiling(a)) {
      var CEIL_FMT = { tiles: 1, 'grid-tiles': 1, rafts: 1, fins: 1, hanging: 1 };
      var pool2 = ceilPool.filter(function (p) { return !primary || p.h !== primary.h; });
      var purpose = pool2.filter(function (p) {
        return p.fmt.some(function (f) { return CEIL_FMT[f]; });
      });
      secondary = best(purpose.length ? purpose : pool2);
    }

    var chosen = {};
    if (primary) chosen[primary.h] = 1;
    if (secondary) chosen[secondary.h] = 1;
    var accent = pool.filter(function (p) { return p.calc === 'accent' && !chosen[p.h]; }).slice(0, 3);
    accent.forEach(function (p) { chosen[p.h] = 1; });

    /* Runners up: the next best that cleared every gate. One per solution
       family, so the list is three real alternatives rather than three
       colourways of the same thing. */
    var fams = {};
    var eligible = pool.filter(function (p) { return !chosen[p.h] && p.calc === 'area'; });
    var runners = eligible.filter(function (p) {
      var fam = p.fmt.join(',') + '|' + p.fin;
      if (fams[fam]) return false;
      fams[fam] = 1;
      return true;
    }).slice(0, 3);
    /* If there are not three distinct families, top up rather than show one
       lonely alternative under a heading that promises several. */
    if (runners.length < 3) {
      eligible.forEach(function (p) {
        if (runners.length < 3 && runners.indexOf(p) === -1) runners.push(p);
      });
    }

    return { primary: primary, secondary: secondary, accent: accent, runners: runners, trace: trace, areas: areas(a) };
  }

  /* Turn the raw metafield text into something that reads correctly after a
     number. "Per unit" became "You will need 16 Per unit", which is nonsense. */
  function unitWords(p, n) {
    var u = String(p.u || '').trim();
    var plural = n === 1 ? '' : 's';
    var noun, note = '';
    if (/per (box|pack)/i.test(u)) { noun = /box/i.test(u) ? 'box' + (n === 1 ? '' : 'es') : 'pack' + plural; note = u; }
    else if (/^per panel/i.test(u)) { noun = 'panel' + plural; }
    else if (/^per (metre|meter)/i.test(u)) { noun = n === 1 ? 'metre' : 'metres'; }
    else if (/^per unit$/i.test(u)) { noun = 'unit' + plural; }
    else if (/^\d+\s+tiles?$/i.test(u)) { noun = 'pack' + plural; note = u + ' per pack'; }
    else if (/tile/i.test(u)) { noun = 'pack' + plural; note = u; }
    else if (/fin/i.test(u)) { noun = 'pack' + plural; note = u; }
    else { noun = 'unit' + plural; note = u && u !== 'unit' ? u : ''; }
    var min = u.match(/min\.?\s*(\d+)/i);
    if (min) note = 'minimum order ' + min[1];
    return { noun: noun, note: note };
  }

  function quantity(p, area) {
    if (!p || p.uc == null || !area) return null;
    var raw = area / p.uc, units = Math.max(p.moq, Math.ceil(raw));
    var w = unitWords(p, units);
    return {
      units: units,
      covered: Math.round(units * p.uc * 10) / 10,
      area: Math.round(area),
      moqBound: raw < p.moq,
      noun: w.noun,
      note: w.note
    };
  }

  /* --- Copy --------------------------------------------------------------- */
  var COPY = {
    framing: {
      high:  "You've asked for full treatment, so we've sized this to cover about half of each surface. That's what it takes for speech to stay clear rather than just softer.",
      mid:   "Moderate treatment covers about a quarter of each surface. It's the right call for most rooms, and it targets the surfaces doing the most damage rather than lining the whole space.",
      basic: "A light treatment covers about a fifth of each surface. You don't have to cover a room to change how it feels."
    },
    /* Keyed to the slot. Previously keyed to the product's format, which gave
       wall tiles the ceiling paragraph on fifteen products. */
    wall: {
      panels: "Wall panels are doing the heavy lifting here. They sit at the height where conversation actually happens, they're the most straightforward surface to work with, and they're the reason a room stops feeling like a hallway.",
      tiles: "Tiles let you treat the wall in pieces rather than in one go, so you can work around windows, switches and whatever else is already on there. They also let you stop when the room sounds right instead of committing to the whole wall up front.",
      roll: "You're covering enough wall that a roll makes more sense than individual panels. It gives you a continuous surface with no joins to line up, and your installer can work to the shape of the room.",
      screens: "Your walls and ceiling are spoken for, so the treatment has to live in the room itself. Screens put absorption directly between the people making the noise and the people hearing it.",
      fallback: "These sit on the wall at the height where conversation actually happens, which is where the absorption does the most good."
    },
    ceiling: {
      tiles: "Your ceiling is the largest uninterrupted surface in the room and the one nothing else is competing for. Fixing directly to it treats the whole space evenly, and it keeps your walls free for whatever else they need to do.",
      panels: "Your ceiling is the largest uninterrupted surface in the room and the one nothing else is competing for. Fixing directly to it treats the whole space evenly, and it keeps your walls free.",
      'grid-tiles': "You already have a drop ceiling, which is the easiest starting point there is. These lift straight into the existing grid, so there's no fixing, no adhesive and no making good afterwards.",
      fins: "With this much height, hanging the treatment down into the room does more than lining the ceiling would. Fins present two faces to the sound instead of one and bring the absorption closer to where people actually are.",
      rafts: "Rafts hang below the ceiling and treat both the top surface and the underside, which is why they suit rooms with height to spare. They also break up a large flat ceiling visually.",
      hanging: "Hanging the treatment into the room, rather than flat against a surface, is the right approach when the ceiling is high or the services are on show. It works with the structure you have instead of fighting it.",
      lighting: "This does acoustic work while reading as a light fitting, which suits spaces where the treatment shouldn't announce itself.",
      fallback: "This treats the ceiling, which is usually the biggest hard surface in the room and the one nothing else is competing for."
    },
    space: {
      office: "It's a standard specification in workplaces, which means it handles daily wear and looks appropriate in a professional setting.",
      education: "It's specified in education regularly, which matters because classrooms are demanding rooms both acoustically and physically.",
      hospitality: "Hospitality rooms have to sound good and look good at once, and this holds up on both counts under commercial use.",
      healthcare: "Healthcare spaces need surfaces that stay presentable and don't complicate cleaning, and this is a common choice in those settings.",
      hall: "Halls are the hardest rooms to get right because of their size and hard surfaces, and this scales to them without the cost running away."
    }
  };

  /* --- Live store data ---------------------------------------------------- */
  var LIVE = {};
  function loadLive(handle) {
    if (typeof fetch !== 'function') return Promise.resolve(null);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) LIVE[handle] = d; return d; })
      .catch(function () { return null; });
  }

  /* --- Component ---------------------------------------------------------- */
  if (customElements.get('acoustic-assessment')) return;

  customElements.define('acoustic-assessment', class extends HTMLElement {
    /* No DOM work in the constructor. Custom element constructors must not
       touch children, and doing so silently kills the upgrade. */
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      this.answers = {};
      this.index = -1;          // -1 = welcome screen
      this.stage = this.querySelector('[data-stage]');
      this.bar = this.querySelector('[data-bar]');

      /* Config comes from a JSON script tag, not an attribute. An attribute
         breaks the moment the copy contains an apostrophe. */
      this.cfg = {};
      try {
        var node = this.querySelector('[data-aa-config]');
        if (node) this.cfg = JSON.parse(node.textContent.trim() || '{}');
      } catch (e) {
        console.error('[acoustic-assessment] config did not parse:', e);
      }

      if (!this.stage) {
        console.error('[acoustic-assessment] missing [data-stage] element');
        return;
      }

      try {
        this.render();
      } catch (e) {
        console.error('[acoustic-assessment] failed to render:', e);
        this.stage.innerHTML =
          '<p>Sorry, the assessment could not load. <a href="' +
          (this.cfg.contactUrl || '/pages/contact') +
          '">Get in touch</a> and we will help directly.</p>';
      }
    }

    visible() {
      var a = this.answers;
      return QUESTIONS.filter(function (q) { return !q.showIf || q.showIf(a); });
    }

    go(step) {
      var list = this.visible();
      var next = this.index + step;
      if (next < 0) { this.index = -1; return this.render(); }
      if (next >= list.length) return this.finish();
      this.index = next;
      this.render();
      this.keepInView();
    }

    set(id, value) { this.answers[id] = value; }

    /* Only scroll if the top of the quiz has gone above the viewport. If the
       question is already visible, leave the page alone — scrolling on every
       click is what made this feel jumpy. scroll-margin-top on the element
       handles the sticky header offset. */
    keepInView() {
      if (!this.getBoundingClientRect || !this.scrollIntoView) return;
      var top = this.getBoundingClientRect().top;
      var offset = parseInt(
        getComputedStyle(this).scrollMarginTop || '0', 10
      ) || 0;
      if (top < offset) {
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    render() {
      if (!this.stage) return;
      if (this.index === -1) return this.renderWelcome();
      var list = this.visible();
      var q = list[this.index];
      if (!q) return this.finish();

      this.bar.style.width = ((this.index) / list.length * 100) + '%';
      this.bar.parentElement.hidden = false;

      var h = '<div class="aa-q">';
      h += '<h2 class="aa-q__title">' + q.title + '</h2>';
      if (q.help) h += '<p class="aa-q__help">' + q.help + '</p>';

      if (q.type === 'single' || q.type === 'multi') {
        h += '<div class="aa-opts" role="group">';
        q.options.forEach(function (o, i) {
          var sel = q.type === 'multi'
            ? (this.answers[q.id] || []).indexOf(o.v) > -1
            : this.answers[q.id] === o.v;
          h += '<button type="button" class="aa-opt" data-i="' + i + '" aria-pressed="' + !!sel + '">' +
               '<span>' + o.label + '</span></button>';
        }, this);
        h += '</div>';
      } else if (q.type === 'number') {
        h += '<div class="aa-num"><input type="number" inputmode="decimal" min="' + q.min +
             '" max="' + q.max + '" step="0.1" value="' + (this.answers[q.id] || '') +
             '" data-num aria-label="' + q.title + '"><span>' + q.suffix + '</span></div>' +
             '<p class="aa-num__warn" data-warn hidden></p>';
      } else if (q.type === 'contact') {
        h += '<div class="aa-fields">' +
             '<input type="text" data-f="name" placeholder="First name" autocomplete="given-name">' +
             '<input type="email" data-f="email" placeholder="Email" autocomplete="email">' +
             '<input type="text" data-f="company" placeholder="Company" autocomplete="organization">' +
             '<input type="text" data-f="postcode" placeholder="Project suburb or postcode">' +
             '</div>';
      }

      h += '<div class="aa-nav">';
      if (this.index > 0 || this.index === 0) h += '<button type="button" class="aa-back" data-back>Back</button>';
      var needsNext = q.type === 'multi' || q.type === 'number' || q.type === 'contact';
      if (needsNext) h += '<button type="button" class="aa-next" data-next>Continue</button>';
      h += '</div></div>';

      this.stage.innerHTML = h;
      this.wire(q);
      var first = this.stage.querySelector('.aa-opt, input');
      if (first) first.focus({ preventScroll: true });
    }

    wire(q) {
      var self = this;
      this.stage.querySelectorAll('.aa-opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var o = q.options[+btn.dataset.i];
          if (q.type === 'single') {
            self.set(q.id, o.v);
            if (q.id === 'problem' && o.v === 'incoming') return self.finish('incoming');
            if (o.exit) return self.finish(o.exit);
            self.go(1);
          } else {
            var cur = (self.answers[q.id] || []).slice();
            if (o.exclusive) {
              cur = cur.indexOf(o.v) > -1 ? [] : [o.v];
            } else {
              cur = cur.filter(function (v) {
                var opt = q.options.filter(function (x) { return x.v === v; })[0];
                return !(opt && opt.exclusive);
              });
              var at = cur.indexOf(o.v);
              at > -1 ? cur.splice(at, 1) : cur.push(o.v);
            }
            self.set(q.id, cur);
            self.render();
          }
        });
      });
      var num = this.stage.querySelector('[data-num]');
      if (num) {
        var warn = this.stage.querySelector('[data-warn]');
        var check = function () {
          var v = parseFloat(num.value);
          var msg = '';
          if (isFinite(v) && v > 0) {
            /* People type 2700 when they mean 2.7. The form data is full of it. */
            if (v > q.max && v / 1000 >= q.min && v / 1000 <= q.max) {
              msg = 'That looks like millimetres. Did you mean ' + (v / 1000) + ' ' + q.suffix + '?';
            } else if (v > q.max) {
              msg = 'That is larger than we can size from here. Tell us about the space and we will work it out with you.';
            } else if (v < q.min) {
              msg = 'That needs to be at least ' + q.min + ' ' + q.suffix + '.';
            }
          }
          if (warn) { warn.textContent = msg; warn.hidden = !msg; }
          self.set(q.id, (isFinite(v) && v >= q.min && v <= q.max) ? v : null);
        };
        num.addEventListener('input', check);
        check();
      }
      this.stage.querySelectorAll('[data-f]').forEach(function (f) {
        f.addEventListener('input', function () {
          self.answers.contact = self.answers.contact || {};
          self.answers.contact[f.dataset.f] = f.value;
        });
      });
      var back = this.stage.querySelector('[data-back]');
      if (back) back.addEventListener('click', function () { self.go(-1); });
      var next = this.stage.querySelector('[data-next]');
      if (next) next.addEventListener('click', function () {
        if (q.type === 'multi' && (self.answers[q.id] || []).length < (q.min || 1)) return;
        if (q.type === 'number' && !self.answers[q.id]) return;
        self.go(1);
      });
    }

    renderWelcome() {
      this.bar.parentElement.hidden = true;
      var layout = this.cfg.imageLayout || 'above';
      var img = this.cfg.image
        ? '<div class="aa-welcome__img"><img src="' + this.cfg.image + '" alt="' +
          String(this.cfg.imageAlt || '').replace(/"/g, '&quot;') + '" loading="eager"></div>'
        : '';
      var body =
        '<h2 class="aa-welcome__title">' + (this.cfg.heading || 'Find the right acoustic treatment for your space') + '</h2>' +
        '<p class="aa-welcome__body">' + (this.cfg.intro || "Answer a few questions about your room and we'll tell you which products suit it, and roughly how much you'll need.") + '</p>' +
        '<div><button type="button" class="aa-cta" data-start>Start now</button></div>' +
        '<p class="aa-welcome__time">Takes about two minutes</p>';

      this.stage.innerHTML =
        '<div class="aa-welcome aa-welcome--' + layout + '">' +
          (layout === 'below' ? body + img : img + body) +
        '</div>';
      var self = this;
      this.stage.querySelector('[data-start]').addEventListener('click', function () { self.go(1); });
    }

    finish(kind) {
      this.bar.parentElement.hidden = true;
      /* Bring the site chrome back before painting the results, so the header
         and footer arrive in the same frame the page content changes. */
      this.revealChrome();
      if (kind === 'incoming') return this.renderIncoming();
      if (kind === 'residential' || kind === 'other') return this.renderScreenOut(kind);
      var res = run(this.answers);
      this.result = res;
      this.renderResults(res);
    }

    /* Residential and "something else" are a quarter of enquiries and ASP does
       not serve them. A silent dead end on question one reads as broken, so
       say so plainly and point them at what they can actually buy. */
    renderScreenOut(kind) {
      var self = this;
      var body = kind === 'residential'
        ? "<p>We work on commercial spaces: offices, schools, healthcare, hospitality and halls. We don't take on residential fitouts, so we'd only be wasting your time pretending otherwise.</p>" +
          "<p>What we can do is sell you the products. Our peel and stick range is designed to be installed by anyone with a tape measure and a spare afternoon, and it's the same material that goes into the commercial jobs.</p>"
        : "<p>The five options above cover the spaces we work in. If yours doesn't fit any of them, we'd rather look at it properly than have the quiz guess.</p>" +
          "<p>Tell us what the space is and what's happening in it, and we'll tell you honestly whether it's something we can help with.</p>";
      this.stage.innerHTML =
        '<div class="aa-result"><div class="aa-caveat">' +
          '<h2>' + (kind === 'residential' ? "We're commercial only, so let's not waste your time" : "Let's look at this one properly") + '</h2>' +
          body +
        '</div>' +
        (kind === 'residential'
          ? '<a class="aa-cta" href="/collections/peel-stick-tiles">Browse the peel and stick range</a>'
          : '<a class="aa-cta" href="' + (this.cfg.contactUrl || '/pages/contact') + '">Tell us about your space</a>') +
        ' <button type="button" class="aa-restart" data-restart>Start again</button></div>';
      var rs = this.stage.querySelector('[data-restart]');
      if (rs) rs.addEventListener('click', function () {
        self.hideChrome(); self.answers = {}; self.index = -1; self.render();
      });
    }

    /* Header and footer are hidden for the questions and restored for the
       results, where people need the nav, the contact details and a way out. */
    revealChrome() {
      if (!document.body.classList.contains('template--bare')) return;
      window.scrollTo({ top: 0, behavior: 'auto' });
      document.body.classList.add('aa-chrome-in');
    }

    hideChrome() {
      document.body.classList.remove('aa-chrome-in');
    }

    renderIncoming() {
      this.stage.innerHTML =
        '<div class="aa-result">' +
          '<div class="aa-caveat">' +
            "<h2>Acoustic panels won't fix this, and we'd rather tell you now</h2>" +
            "<p>What you're describing is noise transfer. Sound is getting from somewhere else into your space, through a wall, a floor, a ceiling, a door gap or a shared duct.</p>" +
            "<p>Acoustic panels absorb sound that's already in the room. They don't block sound from getting in. Putting panels on the wall between you and the noise will change how your room sounds, but it won't meaningfully change how much of next door's noise you hear.</p>" +
            "<p>What actually works is a construction question rather than a product one. It usually comes down to mass, sealing gaps, and separating the two sides of the structure. Door seals and gaps are the cheapest place to start and the most commonly overlooked.</p>" +
          '</div>' +
          '<div class="aa-note"><strong>What we can still help with</strong>' +
          "<p>If the room is also echoey, and most rooms with a noise problem are, treating it will make the space more comfortable to work in even though the noise from next door is unchanged. That's a real improvement, just not the one you came here for. Tell us about the space and we'll give you a straight answer.</p></div>" +
          '<a class="aa-cta" href="' + (this.cfg.contactUrl || '/pages/contact') + '">Tell us about your space</a>' +
          ' <button type="button" class="aa-restart" data-continue>Show me what would help the room itself</button>' +
        '</div>';
      var self = this;
      var cont = this.stage.querySelector('[data-continue]');
      if (cont) cont.addEventListener('click', function () {
        /* Keep going, but remember they also have a transfer problem so the
           caveat block still shows on the results. */
        self.answers.problem = 'both';
        self.hideChrome();
        var list = self.visible();
        for (var i = 0; i < list.length; i++) {
          if (list[i].id === 'surfaces') { self.index = i; break; }
        }
        self.bar.parentElement.hidden = false;
        self.render();
        window.scrollTo({ top: 0, behavior: 'auto' });
      });
    }

    renderResults(res) {
      var a = this.answers, self = this;
      var h = '<div class="aa-result">';

      h += '<div class="aa-sec"><span class="aa-eyebrow">Your assessment</span>' +
           "<h2>Here's what your space needs</h2>" +
           '<p>Based on the surfaces you can use and the result you\'re after. Everything below is sized to the area you gave us.</p></div>';

      h += '<div class="aa-reason"><p>' + COPY.framing[a.result] + '</p></div>';

      if (a.problem === 'escaping' || a.problem === 'both') {
        h += '<div class="aa-caveat"><h3>What this will and won\'t do</h3>' +
             '<p>Panels reduce how much sound builds up inside the room, so less of it presses against the walls and less makes its way through. That\'s often enough for a meeting room where the concern is conversations carrying.</p>' +
             '<p>It won\'t stop sound passing through the structure, and it does nothing for gaps under doors. If full separation is what you need, that\'s a construction job rather than a product one, and we\'d rather tell you that than sell you panels.</p></div>';
      }
      if (a.knowsArea === 'yes' && a.roomLength == null) {
        var big = (a.wallArea && a.wallArea >= 60) || (a.ceilingArea && a.ceilingArea >= 60);
        if (big) {
          h += '<div class="aa-caveat"><p>We have used the panel area you gave us exactly as entered. ' +
               'If that figure was the size of the wall or ceiling rather than the amount of panelling you want on it, ' +
               'the quantities below will be higher than you need. Most rooms are treated at a fifth to a half of the surface.</p></div>';
        }
      }
      if ((a.surfaces || []).indexOf('unsure') > -1) {
        h += '<div class="aa-caveat"><p>You weren\'t sure which surfaces were available, so we\'ve assumed the walls and a solid ceiling are both fair game. If either is off the table, tell us and we\'ll rework this.</p></div>';
      }

      if (!res.primary && !res.secondary) {
        h += '<div class="aa-note"><strong>Let\'s work this one out together</strong>' +
             '<p>Your combination of surfaces and requirements is specific enough that we\'d rather talk it through than guess.</p></div>' +
             '<a class="aa-cta" href="' + (this.cfg.contactUrl || '/pages/contact') + '">Tell us about your space</a></div>';
        this.stage.innerHTML = h;
        return;
      }

      if (res.primary) {
        h += this.slot('Start here', 'Your walls', res.primary, quantity(res.primary, res.areas.wall), res.areas.estimated, 'wall');
      }
      if (res.secondary) {
        h += this.slot(res.primary ? 'Then the ceiling' : 'Start here', 'Your ceiling',
                       res.secondary, quantity(res.secondary, res.areas.ceiling), res.areas.estimated, 'ceiling');
      }
      if ((res.primary ? 1 : 0) + (res.secondary ? 1 : 0) === 1) {
        h += '<div class="aa-note"><p>That\'s the whole recommendation, and that\'s deliberate. Given the surfaces you can use, one product covers what this room needs. We\'d rather give you one thing that\'s right than pad the list out.</p></div>';
      }

      if (res.runners && res.runners.length) {
        h += '<hr class="aa-rule"><div class="aa-sec"><span class="aa-eyebrow">Alternatives</span>' +
             '<h2>These may also work for your space</h2>' +
             '<p>All of these passed the same checks. They came second on absorption or cost, ' +
             'so they are worth a look if the recommendation above is not quite right.</p></div>' +
             '<div class="aa-accent">';
        res.runners.forEach(function (p) {
          var area = p.surf.indexOf('wall') > -1 ? res.areas.wall : res.areas.ceiling;
          var rq = quantity(p, area);
          h += '<a class="aa-accent__item" href="/products/' + p.h + '">' +
               '<span class="aa-accent__img" data-img="' + p.h + '"></span>' +
               '<span class="aa-accent__t">' + p.t + '</span>' +
               (rq ? '<span class="aa-accent__q">' + rq.units + ' ' + rq.noun + '</span>' : '') +
               '</a>';
        });
        h += '</div>';
      }

      if (res.accent.length) {
        h += '<hr class="aa-rule"><div class="aa-sec"><span class="aa-eyebrow">Optional</span><h2>Also worth considering</h2>' +
             '<p>Not part of the recommendation above, and not needed to get the result you\'re after.</p></div><div class="aa-accent">';
        res.accent.forEach(function (p) {
          h += '<a class="aa-accent__item" href="/products/' + p.h + '" data-live="' + p.h + '">' +
               '<span class="aa-accent__img" data-img="' + p.h + '"></span>' +
               '<span class="aa-accent__t">' + p.t + '</span></a>';
        });
        h += '</div>';
      }

      h += '<div class="aa-note"><strong>Made to order</strong><p>Everything we make is made to order, which is why the colour range is what it is. It also means this isn\'t next-day delivery. We\'ll confirm lead times with your quote.</p></div>';

      if (a.install === 'supply-install') {
        h += '<div class="aa-offer"><h3>We can install this for you</h3>' +
             '<p>We install in ' + (this.cfg.installCities || 'Sydney, Melbourne, Brisbane and the Gold Coast') +
             '. Tell us about the site and we\'ll quote supply and install together.</p></div>';
      }

      var cta = {
        researching: ['Ask us a question', "Not ready to commit? Send us the details of your space and we'll give you a straight answer, no pressure."],
        specifying:  ['Request a quote', "Send us your project and we'll come back with pricing on these quantities, plus the specification and fire documentation you'll need."],
        ready:       ['Contact us', "Get in touch and we'll confirm quantities, colours and lead times, then get it into production."]
      }[a.stage] || ['Talk to us about this', ''];
      h += '<div class="aa-final"><p>' + cta[1] + '</p><a class="aa-cta" href="' +
           (this.cfg.contactUrl || '/pages/contact') + '">' + cta[0] + '</a>' +
           '<button type="button" class="aa-restart" data-restart>Start again</button></div>';

      h += '</div>';
      this.stage.innerHTML = h;

      var rs = this.stage.querySelector('[data-restart]');
      if (rs) rs.addEventListener('click', function () {
        self.hideChrome();
        self.answers = {}; self.index = -1; self.render();
        window.scrollTo({ top: 0, behavior: 'auto' });
      });

      [res.primary, res.secondary].concat(res.accent, res.runners || []).filter(Boolean).forEach(function (p) {
        loadLive(p.h).then(function (d) { self.paintLive(p.h, d); });
      });
    }

    slot(eyebrow, heading, p, q, estimated, which) {
      var h = '<hr class="aa-rule"><div class="aa-sec"><span class="aa-eyebrow">' + eyebrow + '</span><h2>' + heading + '</h2></div>';
      /* Copy comes from the slot we are filling, not from the product's format.
         Fifteen wall products list "tiles" as a format and were being handed
         the ceiling paragraph under a "Your walls" heading. */
      var set = COPY[which === 'ceiling' ? 'ceiling' : 'wall'];
      var allowed = allowedFormats(this.answers);
      var key = p.fmt.filter(function (f) { return allowed[f] && set[f]; })[0] ||
                p.fmt.filter(function (f) { return set[f]; })[0] || 'fallback';
      h += '<div class="aa-reason"><p>' + (set[key] || set.fallback) + '</p>';
      if (p.sp.indexOf(this.answers.space) > -1 && COPY.space[this.answers.space]) {
        h += '<p>' + COPY.space[this.answers.space] + '</p>';
      }
      h += '</div>';
      h += '<article class="aa-card" data-card="' + p.h + '">' +
             '<div class="aa-card__img" data-img="' + p.h + '"></div>' +
             '<div class="aa-card__body">' +
               '<h3 class="aa-card__title">' + p.t + '</h3>' +
               '<p class="aa-card__price" data-price="' + p.h + '"></p>';
      if (q) {
        h += '<div class="aa-qty">' +
               '<div><span class="aa-qty__label">You will need</span><strong>' + q.units + ' ' + q.noun + '</strong>' +
                 (q.note ? '<span>' + q.note + '</span>' : '') + '</div>' +
               '<div><span class="aa-qty__label">Covers</span><strong>' + q.covered + ' m²</strong><span>' +
                 (estimated ? 'of panelling, from your room size' : 'against ' + q.area + ' m² requested') + '</span></div>' +
             '</div>';
        if (q.moqBound) h += '<p class="aa-qty__note">This is the minimum order for this product, so it covers a little more than you asked for.</p>';
        if (estimated) h += '<p class="aa-qty__note">Worked out from your room size, covering ' +
          Math.round((this.result && this.result.areas.ratio ? this.result.areas.ratio : 0.25) * 100) +
          '% of the surface. Treat it as a starting point and send us a plan so we can confirm before anything is ordered.</p>';
      } else {
        h += '<p class="aa-qty__note">Quantity confirmed on enquiry. This one is priced per project rather than per square metre.</p>';
      }
      h += '<a class="aa-card__link" href="/products/' + p.h + '">View this product</a>' +
           '</div></article>';
      return h;
    }

    paintLive(handle, d) {
      if (!d) return;
      var img = this.stage.querySelectorAll('[data-img="' + handle + '"]');
      img.forEach(function (el) {
        if (d.featured_image) {
          el.innerHTML = '<img src="' + d.featured_image + '&width=600" alt="' +
                         (d.title || '').replace(/"/g, '') + '" loading="lazy">';
        }
      });
      var price = this.stage.querySelector('[data-price="' + handle + '"]');
      if (price && d.price != null) {
        price.textContent = 'From $' + (d.price / 100).toFixed(2) + ' — colours and sizes on the product page';
      }
    }


  });
})();
